module.exports = __webpack_public_path__ + "static/z_tall_orkin-65789223e890a939ddf6a9578e510c81.jpg";